import React from 'react'
import { SkipNavContent /* SkipNavLink */ } from '@components/skip-nav'
import { Header } from '@components/Header/Header'
import { Footer } from '@components/Footer/Footer'
import BackToTopButton from '@ui/BackToTopButton'
import GoogleOneTap from '@components/GoogleOneTap'
import { useCrisp } from '@hooks/useCrisp'
import { SeoFields } from '@fragments/seo' // don't remove this import
// import ClientOnly from "@components/ClientOnly"
import './Layout.less'

const Layout = ({ children }) => {
  // 初始化 Crisp 客服系统
  useCrisp()

  return (
    <div className="layout-container">
      {/* <SkipNavLink /> */}
      <Header />
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
      <BackToTopButton />
      {/* Google One Tap 一键登录 */}
      <GoogleOneTap
        onSuccess={(userInfo, credential) => {
          console.log('Google One Tap 登录成功:', userInfo)
          // 可以在这里添加额外的成功处理逻辑
        }}
        onError={(error) => {
          console.error('Google One Tap 登录错误:', error)
          // 可以在这里添加错误处理逻辑
        }}
      />
    </div>
  )
}

export default Layout
